import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import { faEraser } from '@fortawesome/pro-solid-svg-icons';

export default class SearchPageCurrentFilters extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    raw: PropTypes.bool,
    onClearFilters: PropTypes.func
  }

  render() {
    return <div className="d-flex justify-content-between gap-2">{this.renderTags()}</div>;
  }

  renderTags() {
    const { children, onClearFilters } = this.props;

    if (React.Children.count(children) === 0) return null;

    return (
      <>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          {children}
        </div>
        <div className="flex-shrink-0">
          <Button icon={faEraser} variant="ghost" onClick={onClearFilters}>
            Clear Filters
          </Button>
        </div>
      </>
    );
  }
}
